var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 24,
    viewBox: "0 0 49 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.92 11.44L30.662 10.271L31.436 9.156C31.751 8.702 31.737 7.987 31.394 7.544L30.682 6.626C30.344 6.189 29.658 6.011 29.152 6.229L27.936 6.753L26.866 6.223L26.516 4.956C26.371 4.428 25.808 4 25.253 4H24.146C23.594 4 23.028 4.429 22.883 4.956L22.533 6.223L21.463 6.753L20.247 6.229C19.74 6.011 19.06 6.182 18.717 6.626L18.005 7.544C17.667 7.981 17.652 8.709 17.963 9.157L18.737 10.272L18.479 11.441L17.322 12.093C16.841 12.365 16.546 13.019 16.665 13.555L16.927 14.735C17.046 15.27 17.587 15.728 18.135 15.758L19.452 15.83L20.178 16.764L19.948 18.13C19.856 18.672 20.183 19.31 20.684 19.559L21.681 20.053C22.179 20.3 22.879 20.157 23.234 19.745L24.119 18.719H25.282L26.167 19.744C26.527 20.161 27.219 20.3 27.719 20.052L28.717 19.558C29.214 19.311 29.544 18.67 29.453 18.129L29.223 16.764L29.949 15.829L31.266 15.757C31.814 15.727 32.355 15.27 32.474 14.734L32.735 13.554C32.854 13.019 32.559 12.364 32.078 12.092L30.921 11.44H30.92Z",
    stroke: "#00067E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4502 12.25C27.4502 12.9793 27.1605 13.6788 26.6447 14.1945C26.129 14.7103 25.4295 15 24.7002 15C23.9708 15 23.2714 14.7103 22.7557 14.1945C22.2399 13.6788 21.9502 12.9793 21.9502 12.25C21.9502 11.5207 22.2399 10.8212 22.7557 10.3055C23.2714 9.78973 23.9708 9.5 24.7002 9.5C25.4295 9.5 26.129 9.78973 26.6447 10.3055C27.1605 10.8212 27.4502 11.5207 27.4502 12.25Z",
    stroke: "#00067E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.d5a0137082633064f7cef29bce6b14b0.svg";
export { ForwardRef as ReactComponent };